<template>
  <section class="faq-page__wrapper clearfix">
    <header class="faq-page__header">
      <h1>Frequently Asked Questions</h1>
    </header>

    <Faq class="faq" :faqs="faqs" />

    <footer class="faq-page__footer">
      <p>
        Can't find the answers you're looking for? You can reach out to us
        directly using one of the social media channels below, or you can also
        visit the Bohemia Interactive
        <a href="https://support.bohemia.net/" target="_blank">Support page</a>.
      </p>
    </footer>
  </section>
</template>

<script>
import Faq from "@/components/FaqWrapper";

import { FaqResource } from "@/services";

export default {
  components: {
    Faq
  },
  data() {
    return {
      faqs: []
    };
  },
  metaInfo: {
    title: "F.A.Q."
  },
  methods: {
    async loadData() {
      const response = await FaqResource.get();

      this.faqs = response.data;
    }
  },
  created() {
    this.loadData();
  }
};
</script>
